import React from "react";

import ReactBeforeSliderComponent from "react-before-after-slider-component";
import "react-before-after-slider-component/dist/build.css";

const BeforeSlider = ({ was, became, styles }) => {
  return (
    <div className="before-after-swipe">
      <ReactBeforeSliderComponent
        firstImage={was}
        secondImage={became}
        delimiterColor="#d9d9d9"
        delimiterIconStyles={styles}
        className="delimiter"
      />
    </div>
  );
};

export default BeforeSlider;
